import React, { useEffect, useState, Suspense, lazy, createElement } from 'react';
import { Hero } from './components/Hero';
const StatsAndTestimonials = lazy(() => import('./components/StatsAndTestimonials').then(m => ({
  default: m.StatsAndTestimonials
})));
const PainPoints = lazy(() => import('./components/PainPoints').then(m => ({
  default: m.PainPoints
})));
const Modules = lazy(() => import('./components/Modules').then(m => ({
  default: m.Modules
})));
const PlanillasPreview = lazy(() => import('./components/PlanillasPreview').then(m => ({
  default: m.PlanillasPreview
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const IsForYou = lazy(() => import('./components/IsForYou').then(m => ({
  default: m.IsForYou
})));
const Pricing = lazy(() => import('./components/Pricing').then(m => ({
  default: m.Pricing
})));
const CostComparison = lazy(() => import('./components/CostComparison').then(m => ({
  default: m.CostComparison
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const PurchaseToast = lazy(() => import('./components/PurchaseToast').then(m => ({
  default: m.PurchaseToast
})));
export function App() {
  const [showPurchaseToast, setShowPurchaseToast] = useState(false);
  useEffect(() => {
    document.documentElement.lang = 'es-AR';
    document.title = 'Sistema Maestro PVC + DVH™ — Todo tu taller de PVC + DVH listo. Desde hoy.';
    const metaDesc = document.querySelector('meta[name="description"]') || document.createElement('meta');
    metaDesc.setAttribute('name', 'description');
    metaDesc.setAttribute('content', 'El sistema definitivo para carpinteros e instaladores de aberturas en Argentina. 6 Módulos + 3 Bonos. Fórmulas, tablas de corte y protocolos listos para usar.');
    if (!document.querySelector('meta[name="description"]')) document.head.appendChild(metaDesc);
    if (!document.querySelector('meta[name="viewport"]')) {
      const viewport = document.createElement('meta');
      viewport.setAttribute('name', 'viewport');
      viewport.setAttribute('content', 'width=device-width, initial-scale=1');
      document.head.appendChild(viewport);
    }
    const runDeferredSetup = () => {
      if (!document.querySelector('meta[name="theme-color"]')) {
        const themeColor = document.createElement('meta');
        themeColor.setAttribute('name', 'theme-color');
        themeColor.setAttribute('content', '#0a1628');
        document.head.appendChild(themeColor);
      }
    };
    const prefetchChunks = () => {
      import('./components/StatsAndTestimonials');
      import('./components/PainPoints');
      import('./components/Modules');
      setTimeout(() => {
        import('./components/PlanillasPreview');
        import('./components/Bonuses');
        import('./components/IsForYou');
      }, 300);
      setTimeout(() => {
        import('./components/Pricing');
        import('./components/CostComparison');
        import('./components/FinalCTA');
      }, 800);
      setTimeout(() => {
        import('./components/Footer');
        import('./components/PurchaseToast');
      }, 1500);
    };
    const mountToast = () => {
      setShowPurchaseToast(true);
      window.removeEventListener('scroll', mountToast);
      window.removeEventListener('pointerdown', mountToast);
      window.removeEventListener('keydown', mountToast);
    };
    window.addEventListener('scroll', mountToast, {
      once: true,
      passive: true
    });
    window.addEventListener('pointerdown', mountToast, {
      once: true,
      passive: true
    });
    window.addEventListener('keydown', mountToast, {
      once: true,
      passive: true
    });
    const ric: any = (window as any).requestIdleCallback || ((cb: any) => setTimeout(cb, 1));
    const cic: any = (window as any).cancelIdleCallback || ((id: any) => clearTimeout(id));
    const prefetchId = ric(prefetchChunks, {
      timeout: 500
    });
    const idleId = ric(runDeferredSetup, {
      timeout: 1500
    });
    return () => {
      cic(idleId);
      cic(prefetchId);
      window.removeEventListener('scroll', mountToast);
      window.removeEventListener('pointerdown', mountToast);
      window.removeEventListener('keydown', mountToast);
    };
  }, []);
  return <div className="min-h-screen text-gray-200 font-body selection:bg-gold selection:text-bg antialiased" data-id="element-0">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:bg-gold focus:text-bg focus:px-4 focus:py-2 focus:rounded-lg focus:font-bold" data-id="element-1">
        Saltar al contenido principal
      </a>
      <main id="main-content" data-id="element-2">
        <Hero data-id="element-3" />
        <div className="lazy-sections" data-id="element-4">
          <Suspense fallback={null} data-id="element-5">
            <StatsAndTestimonials data-id="element-6" />
            <PainPoints data-id="element-7" />
            <Modules data-id="element-8" />
            <PlanillasPreview data-id="element-9" />
            <Bonuses data-id="element-10" />
            <IsForYou data-id="element-11" />
            <Pricing data-id="element-12" />
            <CostComparison data-id="element-13" />
            <FinalCTA data-id="element-14" />
          </Suspense>
        </div>
      </main>
      <Suspense fallback={null} data-id="element-15">
        <Footer data-id="element-16" />
        {showPurchaseToast && <PurchaseToast data-id="element-17" />}
      </Suspense>
    </div>;
}